import React from "react";
import ReactDOM from "react-dom";
import ContactForm from "./components/ContactForm";

export const render = (selector, locale) => {
  const element = document.querySelector(selector);

  ReactDOM.render(
    <ContactForm
        formId="mayvdrdn"
        locale={locale}
    />, element)
  ;
}
